import { render, staticRenderFns } from "./ExamineeDetails.vue?vue&type=template&id=ecee25fc&scoped=true&"
import script from "./ExamineeDetails.vue?vue&type=script&lang=js&"
export * from "./ExamineeDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExamineeDetails.vue?vue&type=style&index=0&id=ecee25fc&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecee25fc",
  null
  
)

export default component.exports